<template>
  <div class="info-header info-head">
    <span v-if="(brand_white1 || brand_translux5) && screenConfiguration.is2showsingleevent && liveEventAppearsOnScreen" class="live-icon">LIVE</span>

    <sport-icon v-if="showparticipantlogo && (brand_white1 || brand_translux5)" :event="event"></sport-icon>

    <h2 class="sport-name text-overflow"><span class="text-overflow">{{ event.fosporttypename || event.idfosporttype }}</span></h2>
    <span class="team-name text-overflow"><span class="text-overflow">{{ event.eventname }}</span></span>
    <span v-if="(brand_white1 || brand_translux5) && event.half === 0 && currentRotateIndex !== undefined && maxRotationIndex !== undefined" class="paging-index">PAGE {{ currentRotateIndex + 1 }} of {{ maxRotationIndex + 1 }}</span>
    <span v-else-if="(brand_white1 || brand_translux5) && event.half === 1 && currentRotateIndex1 !== undefined && maxRotationIndex1 !== undefined" class="paging-index">PAGE {{ currentRotateIndex1 + 1 }} of {{ maxRotationIndex1 + 1 }}</span>
    <span v-else="(brand_white1 || brand_translux5) && currentRotateIndex !== undefined && maxRotationIndex !== undefined" class="paging-index">PAGE {{ currentRotateIndex + 1 }} of {{ maxRotationIndex + 1 }}</span>

    <div v-if="(brand_white1 || brand_translux5) && !brand_ultrawide" class="clock">
      <span v-if="(brand_white1 || brand_translux5)" class="date">
        {{event.tsExpectedStart | moment(dateFormats.dayAndMonthInverse) }}
      </span>
      <span v-else class="date">
        {{ event.tsExpectedStart | moment(dateFormats.dayAndMonth) }}
      </span>
      <span class="time">
        <span v-if="event.idfobolifestate === 'O'">
          <span class="hour">{{ event.tsExpectedStart | moment(dateFormats.shortTime) }} {{ event.tsExpectedStart | moment('A') }}</span>
        </span>
        <span v-else>{{ $t('Finished') }}</span>
      </span>
    </div>
    <span v-else class="time">
      <span v-if="event.idfobolifestate === 'O'">
        <span class="day" v-if="isDateToday">Today</span>
        <span class="day" v-if="isDateTomorrow">Tomorrow</span>
        <span class="day long-date" v-if="!isDateToday && !isDateTomorrow">{{ event.tsExpectedStart | moment(dateFormats.longDate) }}</span>
        <span class="day day-month-reverse" v-if="!isDateToday && !isDateTomorrow">{{ event.tsExpectedStart | moment(dateFormats.dayAndMonthInverse) }}</span>
        <span class="hour">{{ event.tsExpectedStart | moment(dateFormats.shortTime) }} {{ event.tsExpectedStart | moment('A') }}</span>
      </span>
      <span v-else>{{ $t('Finished') }}</span>
    </span>
  </div>
</template>

<script>
  import BettingOffer from '@/components/mixins/BettingOffer'
  import Brands from '@/components/mixins/Brands'
  import store from '@/store'

  import Icon from '@/components/common/Icon'
  import SportIcon from '@/components/common/SportIcon'

  export default {
    name: 'cdu-info-head',

    mixins: [
      BettingOffer,
      Brands
    ],

    components: {
      Icon,
      SportIcon
    },

    props: [
      'event'
    ],

    data () {
      return {
      }
    },

    computed: {
      liveEventAppearsOnScreen () {
        return this.event.isliveevent && this.event.idfobolifestate === 'O'
      },
      maxRotationIndex () {
        return store.getters['bettingOfferState/getMaxRotationIndex']
      },
      maxRotationIndex1 () {
        return store.getters['bettingOfferState/getMaxRotationIndex1']
      },
      currentRotateIndex () {
        return store.getters['bettingOfferState/getCurrentRotateIndex']
      },
      currentRotateIndex1 () {
        return store.getters['bettingOfferState/getCurrentRotateIndex1']
      },
      isDateTomorrow () {
        return this.isTomorrow
      },
      isDateToday () {
        return this.isToday
      },
      showparticipantlogo () {
        return this.current_brand_cnfiguration.showParticipantLogos
      }
    },

    methods: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  @import '~@/css/config'
</style>



// WEBPACK FOOTER //
// src/components/cdu/cduInfoHead.vue